module.exports = __webpack_public_path__ + "static/media/bg-home-succession--sp.45ba1347.jpg";